import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-types`, formData);
  },
  async findOne({id}) {
    return axios.get(`/rent-object-types/${id}`);
  },
  async findAll() {
    return axios.get(`/rent-object-types`);
  },
  async findAllFull() {
    return axios.get(`/rent-object-types/full`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-types/${id}`);
  },
  async update({ id, name, icon, layout }) {
    return axios.put(`/rent-object-types/${id}`, {id, name, icon, layout});
  },
  async updateDocumentContent(formData) {
    return axios.put(`/rent-object-types/document-content`, formData);
  },
  async updateColors(formData) {
    return axios.put(`/rent-object-types/colors`, {rentObjectTypes: formData});
  },
  async getColumns() {
    return axios.get(`/rent-object-types/columns`);
  }
};
